import { createStore } from "vuex";

import cmsModule from "./modules/cms";
import timerModule from "./modules/timer";
import toastModule from "./modules/toast";
import userModule from "./modules/user";
import filterModule from "./modules/filter";
import profileModule from "./modules/profile";
import conferenceModule from "./modules/conference";

const store = createStore({
  modules: {
    cms: cmsModule,
    timer: timerModule,
    toast: toastModule,
    user: userModule,
    filter: filterModule,
    profile: profileModule,
    conference: conferenceModule
  },
});

export default store;
